export class Screen {
    /**
     * @param {boolean|null} isTurnedOn Whether the screen is turned on or off. Null if not known.
     */
    constructor(identifier, label, offsetX, offsetY, width, height, scaleFactor, rotation, frequency, outputPort = null, isTurnedOn = null) {
        this.identifier = identifier;
        this.label = label;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.width = width;
        this.height = height;
        this.scaleFactor = scaleFactor;
        this.rotation = rotation;
        this.frequency = frequency;
        this.outputPort = outputPort;
        this.isTurnedOn = isTurnedOn;
        this.availableModes = null;
    }
    serialize() {
        const result = {
            id: this.identifier,
            label: this.label,
            width: this.width,
            height: this.height,
            scaleFactor: this.scaleFactor,
            rotation: this.rotation,
            displayFrequency: this.frequency,
            outputPort: this.outputPort,
        };
        if (this.availableModes) {
            result.availableModes = this.availableModes;
        }
        return result;
    }
}
//# sourceMappingURL=Screen.js.map